import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { SharedService } from 'app/services/core/shared.service';
import { IFoaReportViewModel } from 'app/models/report/reports';
import { ILabApplication } from 'app/models/application-menu/lab-application';
import { IPts } from 'app/models/pt/pt';

@Component({
  selector: 'ptPassedReport',
  templateUrl: './ptPassedReport.component.html',
  styleUrls: ['./ptPassedReport.component.scss']
})
export class PtPassedReportComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;
  public orelapId: string = '';
  public epaId: string = '';
  public appId: string = '';
  public viewList: IPts[] = [];
  public PT_NOT_FOUND_ON_APP: string = "Analyte Not Found on APPID"
  public labApp: ILabApplication = null;
  public fromDate: string = '';
  public toDate: string = '';
  public numberOfColumns: number = 0;
  
  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<PtPassedReportComponent>,
    private labApplicationMenuService: LabApplicationMenuService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('data passed to pt success report', data);
    this.labApp = this.sharedService.currentApplication;
    this.viewList = this.data.viewList;
    this.fromDate = this.data.from;
    this.toDate = this.data.to;
    this.orelapId = this.data.orelapId;
    this.numberOfColumns = this.data.numberOfColumns;
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Foa_Report.pdf');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
